import React from 'react';
import ReactDOM from 'react-dom';
import { createRoot } from 'react-dom/client';
//router

//redux
import { Provider } from 'react-redux';
import store from './redux/store';
//codesplitting

import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { baseURL } from './redux/apis/main-api';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
	<Provider store={store}>
		<BrowserRouter basename={baseURL}>
			<App />
		</BrowserRouter>
	</Provider>
);

if (module.hot) {
	module.hot.accept();
}
